import { render } from "./SavedFiltersDropDown.vue?vue&type=template&id=622b6322&scoped=true"
import script from "./SavedFiltersDropDown.vue?vue&type=script&lang=js"
export * from "./SavedFiltersDropDown.vue?vue&type=script&lang=js"

import "./SavedFiltersDropDown.vue?vue&type=style&index=0&id=622b6322&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b6322"]])

export default __exports__